export default "__VITE_ASSET__CC6FiD9n__"